"use client";

import type { ISbStoryData } from "@storyblok/react/rsc";
import { AlertCircle } from "lucide-react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { FaqEntryStoryblok, FaqStoryblok } from "@/component-types-sb";

interface FaqAccordionProps {
  blok: FaqStoryblok;
  initialQueryResult: {
    stories: ISbStoryData[];
    total: number;
  };
}

const FaqAccordionClient: React.FC<FaqAccordionProps> = ({ blok, initialQueryResult }) => {
  const stories = initialQueryResult?.stories || [];
  const faqEntries = stories.map((story: ISbStoryData) => story.content) as FaqEntryStoryblok[];

  if (!initialQueryResult) {
    return (
      <div className="flex flex-col items-start text-red-500">
        <div className="flex items-center gap-2 mb-2">
          <AlertCircle className="h-5 w-5" />
          <p>Error loading FAQs</p>
        </div>
        <p className="text-sm text-gray-500">
          Unknown error
        </p>
      </div>
    );
  }

  if (!faqEntries || faqEntries.length === 0) {
    return <p>Momentan keine FAQs vorhanden!</p>;
  }

  return (
    <Accordion type="multiple">
      {faqEntries.map((entry, index) => (
        <AccordionItem key={`${blok._uid}-${index.toString()}`} value={`${blok._uid}-${index.toString()}`}>
          <AccordionTrigger>{entry.question || "Question"}</AccordionTrigger>
          <AccordionContent>{entry.anwer || "No answer provided"}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default FaqAccordionClient;
